var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _g, _path34, _path35, _path36, _g2, _path37, _path38, _path39, _g3, _path40, _path41, _path42, _path43, _path44;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRobotSleep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 496,
    height: 380,
    viewBox: "0 0 496 380",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M453.427 299.833C453.427 299.833 443.354 311.818 453.427 321.484C453.427 321.484 438.427 323.625 438.427 309.271C438.427 294.917 453.427 299.833 453.427 299.833Z",
    fill: "#0A1324"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M274.958 210.563C275.797 204.104 262.536 198.005 262.536 198.005C251.161 192.026 238.87 195.385 238.87 195.385C220.328 199.193 222.245 208.224 222.245 208.224L274.958 210.563Z",
    fill: "#0A1324"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M429.552 302.422L392.375 299.714L341.13 279.661C324.156 268.901 304.891 225.714 304.891 225.714L297.74 227.469L296.167 261.797L302.708 269.292C302.708 269.292 307.958 279.839 323.005 292.026L391 321.427L430.469 321.484",
    fill: "#1F3E76"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M361.526 287.646L341.115 279.661C339.167 278.417 337.177 276.755 335.203 274.776C332.552 289.849 318.677 288.339 318.677 288.339C320.026 289.536 321.463 290.781 323.005 292.026L355.375 306.021L361.526 287.646Z",
    fill: "#0A1324"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M301.646 291.724L304.906 225.714C304.906 225.714 300.792 215.901 274.958 210.563C218.141 198.828 187.057 219.51 187.057 219.51L185.484 273.74C185.484 273.74 185.557 295.469 185.661 313.047C185.771 330.625 216.708 327.87 216.708 327.87L286.646 328.948L301.63 327.87V291.724H301.646Z",
    fill: "#87B4DE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M222.677 219.646C222.677 219.646 268.146 209.036 297.74 227.484L296.167 261.813L225.984 260.104L222.677 219.646Z",
    fill: "#1F3E76"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M269.766 241.401V235.411H256.292V227.917H269.766V221.922H253.344L250.307 224.948V251.953L253.344 254.891H269.766V248.896H256.292V241.401H269.766Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M203.937 103.432L193.792 149.318C193.177 152.078 193.568 154.953 194.885 157.458L210.406 186.964C212.245 190.453 215.703 192.823 219.625 193.255L307.318 202.995C312.917 203.609 318.182 200.224 319.932 194.875L336.292 144.99C337.641 140.87 336.651 136.344 333.703 133.167L306.911 104.318C304.875 102.13 302.094 100.781 299.115 100.557L216.479 94.1458C210.568 93.6771 205.224 97.651 203.937 103.432Z",
    fill: "#87B4DE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M336.292 144.958L319.932 194.859C318.182 200.208 312.917 203.609 307.318 202.979L219.625 193.24C217.917 193.047 216.318 192.505 214.88 191.651L228.531 134.635C229.969 128.625 235.745 124.729 241.833 125.63L336.771 139.667C337.01 141.438 336.865 143.234 336.292 144.958Z",
    fill: "#1F3E76"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M227.615 118.016L209.808 97.5312",
    stroke: "#0A1324",
    strokeWidth: 1.49762,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M243.677 165.474L267.656 169.682C267.656 169.682 262.578 181.089 251.906 178.813C241.24 176.531 243.677 165.474 243.677 165.474Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M286.75 172.292L311.042 176.203C311.042 176.203 308.427 185.99 295.12 184.417C281.828 182.844 286.75 172.292 286.75 172.292Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M341.563 331.781L301.583 327.885C301.583 327.885 292.797 323.583 292.797 310.036C292.797 296.49 301.583 291.74 301.583 291.74L337.911 291.875",
    fill: "#1F3E76"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M372.437 251.234C354.87 247.354 336.443 274.656 336.443 307.891C336.443 341.13 353.01 343.109 375.016 343.109",
    fill: "#3279AF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M372.437 251.234C392.448 253 403.719 339.12 375.026 343.109C346.338 347.094 348.568 249.12 372.437 251.234Z",
    fill: "#0A1324"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M306.089 291.771C306.089 291.771 297.079 312.599 311.6 328.963",
    stroke: "#0A1324",
    strokeWidth: 1.49762,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M319.188 291.859C319.188 291.859 315.027 316.943 330.563 330.969",
    stroke: "#0A1324",
    strokeWidth: 1.49762,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5105 294.406C82.5105 294.406 117.625 297.943 140.495 283.708C164.365 268.844 187.057 219.51 187.057 219.51C187.057 219.51 195.734 217.969 200.948 231.229C206.156 244.474 199.193 254.516 199.193 254.516C199.193 254.516 173.703 295.141 148.995 309.375C124.281 323.615 83.797 316.432 83.797 316.432",
    fill: "#1F3E76"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M180.875 231.766C180.875 231.766 188.24 235.229 190.469 267.239",
    stroke: "#0A1324",
    strokeWidth: 1.49762,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M169.068 251.865C169.068 251.865 177.672 261.469 174.62 287.031",
    stroke: "#0A1324",
    strokeWidth: 1.49762,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M152.287 273.739C152.287 273.739 159.219 290.797 151.511 307.849",
    stroke: "#0A1324",
    strokeWidth: 1.49762,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M130.047 288.786C130.047 288.786 131.604 308.495 118.61 317.766",
    stroke: "#0A1324",
    strokeWidth: 1.49762,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M103.36 294.359C103.36 294.359 103.063 310.755 94.0627 317.286",
    stroke: "#0A1324",
    strokeWidth: 1.49762,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M463.677 321.427L477.057 319.927V328.031L463.427 334.224",
    fill: "#0A1324"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M463.427 287.021L477.057 292.052V299.698L463.677 299.714",
    fill: "#0A1324"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M440.807 310.604C440.974 324.302 463.693 321.427 463.693 321.427L463.438 334.224C446.287 333.651 428.25 329.5 427.984 311.745C427.714 293.984 443.13 286.417 463.469 287.021L463.755 299.714C463.74 299.714 440.646 296.906 440.807 310.604Z",
    fill: "#3279AF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M314.261 244.417C314.261 244.417 317.256 268.484 309.49 278.911",
    stroke: "#0A1324",
    strokeWidth: 1.49762,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M328.704 267.24C328.704 267.24 334.094 282.687 328.704 291.859",
    stroke: "#0A1324",
    strokeWidth: 1.49762,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M418.194 301.599C418.194 301.599 414.949 315.114 424.256 321.484",
    stroke: "#0A1324",
    strokeWidth: 1.49762,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M399.98 300.266C399.98 300.266 396.761 314.604 405.652 321.427",
    stroke: "#0A1324",
    strokeWidth: 1.49762,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M255.547 110.776C255.547 110.776 256.667 91.6406 279.974 94.099C303.292 96.5729 302.005 116.187 302.005 116.187C302.005 116.187 299.563 120.922 284.026 119.573C268.495 118.224 255.547 110.776 255.547 110.776Z",
    fill: "#3279AF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M274.584 100.469L255.547 43.0468",
    stroke: "#0A1324",
    strokeWidth: 1.49762,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_102_205",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 245,
    y: 33,
    width: 21,
    height: 19
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M245.333 33.0938H265.333V52H245.333V33.0938Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_102_205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.479 42.0417C264.479 42.6302 264.422 43.2083 264.307 43.7865C264.193 44.3594 264.026 44.9219 263.802 45.4635C263.578 46.0052 263.302 46.5208 262.974 47.0104C262.651 47.5 262.281 47.9531 261.865 48.3646C261.448 48.7813 261 49.151 260.51 49.4792C260.021 49.8073 259.505 50.0833 258.964 50.3073C258.422 50.5313 257.865 50.6979 257.286 50.8125C256.714 50.9271 256.13 50.9844 255.547 50.9844C254.958 50.9844 254.38 50.9271 253.802 50.8125C253.229 50.6979 252.667 50.5313 252.125 50.3073C251.583 50.0833 251.068 49.8073 250.583 49.4792C250.094 49.151 249.641 48.7813 249.229 48.3646C248.813 47.9531 248.443 47.5 248.115 47.0104C247.792 46.5208 247.516 46.0052 247.292 45.4635C247.068 44.9219 246.896 44.3594 246.781 43.7865C246.667 43.2083 246.609 42.6302 246.609 42.0417C246.609 41.4531 246.667 40.8698 246.781 40.2969C246.896 39.7187 247.068 39.1615 247.292 38.6146C247.516 38.0729 247.792 37.5573 248.115 37.0677C248.443 36.5833 248.813 36.1302 249.229 35.7135C249.641 35.2969 250.094 34.9271 250.583 34.6042C251.068 34.276 251.583 34 252.125 33.776C252.667 33.5521 253.229 33.3802 253.802 33.2656C254.38 33.151 254.958 33.0938 255.547 33.0938C256.13 33.0938 256.714 33.151 257.286 33.2656C257.865 33.3802 258.422 33.5521 258.964 33.776C259.505 34 260.021 34.276 260.51 34.6042C261 34.9271 261.448 35.2969 261.865 35.7135C262.281 36.1302 262.651 36.5833 262.974 37.0677C263.302 37.5573 263.578 38.0729 263.802 38.6146C264.026 39.1615 264.193 39.7187 264.307 40.2969C264.422 40.8698 264.479 41.4531 264.479 42.0417Z",
    fill: "#3279AF"
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M285.855 102.745L306.407 73.6614L335.037 100.469",
    stroke: "#0A1324",
    strokeWidth: 1.49762,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M345.755 102.729C345.755 103.318 345.698 103.901 345.583 104.474C345.469 105.052 345.297 105.609 345.073 106.156C344.849 106.698 344.573 107.214 344.245 107.703C343.922 108.188 343.552 108.641 343.135 109.057C342.719 109.474 342.271 109.844 341.781 110.167C341.292 110.495 340.781 110.771 340.234 110.995C339.693 111.219 339.135 111.391 338.562 111.505C337.984 111.62 337.406 111.677 336.818 111.677C336.229 111.677 335.651 111.62 335.073 111.505C334.5 111.391 333.937 111.219 333.396 110.995C332.854 110.771 332.338 110.495 331.854 110.167C331.365 109.844 330.911 109.474 330.5 109.057C330.083 108.641 329.713 108.188 329.385 107.703C329.062 107.214 328.786 106.698 328.562 106.156C328.338 105.609 328.167 105.052 328.052 104.474C327.937 103.901 327.88 103.318 327.88 102.729C327.88 102.141 327.937 101.563 328.052 100.984C328.167 100.411 328.338 99.849 328.562 99.3073C328.786 98.7656 329.062 98.25 329.385 97.7604C329.713 97.2708 330.083 96.8177 330.5 96.4063C330.911 95.9896 331.365 95.6198 331.854 95.2917C332.338 94.9636 332.854 94.6875 333.396 94.4636C333.937 94.2396 334.5 94.0729 335.073 93.9583C335.651 93.8438 336.229 93.7865 336.818 93.7865C337.406 93.7865 337.984 93.8438 338.562 93.9583C339.135 94.0729 339.693 94.2396 340.234 94.4636C340.781 94.6875 341.292 94.9636 341.781 95.2917C342.271 95.6198 342.719 95.9896 343.135 96.4063C343.552 96.8177 343.922 97.2708 344.245 97.7604C344.573 98.25 344.849 98.7656 345.073 99.3073C345.297 99.849 345.469 100.411 345.583 100.984C345.698 101.563 345.755 102.141 345.755 102.729Z",
    fill: "#3279AF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_102_205",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 277,
    width: 81,
    height: 58
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35938 277.333H89.3333V334.667H9.35938V277.333Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_102_205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.2657 317.438C80.5365 332.094 51.349 333.427 51.349 333.427L37.0417 319.729L40.3022 306.125L21.7292 310.724L10.3074 302.422L12.7188 280.906C12.7188 280.906 51.5886 273.771 72.7501 282.896C93.9428 292.036 89.9949 302.797 85.2657 317.438Z",
    fill: "#0A1324"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6719 307.276L42.6094 296.563C42.6094 296.563 77.8542 296.417 65.5677 288.875C53.2813 281.339 24.7969 291.125 24.7969 291.125L12.7188 280.906C12.7188 280.906 51.5885 273.771 72.75 282.896C78.7813 285.505 82.7813 288.234 85.2917 291.156C93.1667 302.917 59.6719 307.276 59.6719 307.276Z",
    fill: "#3279AF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M59.672 307.276L51.349 333.427L37.0574 319.729L42.6095 296.562L59.672 307.276Z",
    fill: "#87B4DE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_102_205",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 280,
    width: 17,
    height: 32
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35938 280H25.3333V312H9.35938V280Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_102_205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8126 291.125L21.7292 310.724L10.323 302.422L12.7345 280.906L24.8126 291.125Z",
    fill: "#87B4DE"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M256.698 331.781L216.719 327.885C216.719 327.885 207.938 323.583 207.938 310.036C207.938 296.49 216.719 291.74 216.719 291.74L253.047 291.875",
    fill: "#1F3E76"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M287.573 251.234C270.005 247.354 251.578 274.656 251.578 307.891C251.578 341.13 268.146 343.109 290.151 343.109",
    fill: "#3279AF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M287.573 251.234C307.589 253 318.859 339.12 290.167 343.109C261.474 347.094 263.703 249.12 287.573 251.234Z",
    fill: "#0A1324"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M221.224 291.771C221.224 291.771 212.214 312.599 226.735 328.963",
    stroke: "#0A1324",
    strokeWidth: 1.49762,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M234.323 291.859C234.323 291.859 230.162 316.943 245.698 330.969",
    stroke: "#0A1324",
    strokeWidth: 1.49762,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotSleep);
export default __webpack_public_path__ + "static/media/robot-sleep.e084200cb9e3a8954ceb0f3585be0a84.svg";
export { ForwardRef as ReactComponent };